/*
 *
 * 　　┏┓　　　┏┓+ +
 * 　┏┛┻━━━┛┻┓ + +
 * 　┃　　　　　　　┃
 * 　┃　　　━　　　┃ ++ + + +
 *  ████━████ ┃+
 * 　┃　　　　　　　┃ +
 * 　┃　　　┻　　　┃
 * 　┃　　　　　　　┃ + +
 * 　┗━┓　　　┏━┛
 * 　　　┃　　　┃
 * 　　　┃　　　┃ + + + +
 * 　　　┃　　　┃
 * 　　　┃　　　┃ +  神兽保佑
 * 　　　┃　　　┃    代码无bug
 * 　　　┃　　　┃　　+
 * 　　　┃　 　　┗━━━┓ + +
 * 　　　┃ 　　　　　　　┣┓
 * 　　　┃ 　　　　　　　┏┛
 * 　　　┗┓┓┏━┳┓┏┛ + + + +
 * 　　　　┃┫┫　┃┫┫
 * 　　　　┗┻┛　┗┻┛+ + + +
 *
 *
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-12-28 15:43:26
 * @LastEditTime: 2022-03-18 14:33:37
 * @FilePath: \news2021\src\router\index.js
 * @Description:
 */

import VueRouter from 'vue-router'
import Vue from 'vue'

import index from '../components/index.vue'
import desc from '../components/desc.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: 'Chinese Traditional Festivals'
    },
    component: index
  },
  {
    path: '/:tabListTitle',
    name: 'desc',
    meta: {
      title: 'Chinese Traditional Festivals'
    },
    component: desc
  }
]

const router = new VueRouter({
  routes
})

export default router
